export enum QueryParam {
  QUERY = 'q',
  ENCODED_QUERY = 'e',
  HIDE_QUERY_BUILDER = 'hideQb',
}
